<template>
  <div>

    <Head :title="connector.id" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/connectors">Connector</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ connector.id }}
    </h1>
    <div class="max-w-5xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full lg:w-1/2" label="Title" />
          <text-input v-model="form.type" :error="form.errors.type" class="pb-8 pr-6 w-full opacity-80 lg:w-1/2"
            label="Type" disabled />
          <text-input v-model="form.source" class="pb-8 pr-6 opacity-80 w-full" label="Source" disabled />
          <div class="flex flex-wrap w-full" v-if="form.source == 'shopify' && form.type == 'export'">
            <text-input v-model="form.source_json.export" class="pb-8 pr-6 opacity-80 w-full" label="Export" disabled />
            <text-input v-model="form.source_json.shop_domain" class="pb-8 pr-6 w-full lg:w-1/2" label="Shop Domain" />
            <text-input v-model="form.source_json.api_access_token" class="pb-8 pr-6 w-full lg:w-1/2"
              label="Api Access Token" />
          </div>
          <text-input v-model="form.destination" class="pb-8 pr-6 opacity-80 w-full" label="Destination" disabled />
          <div class="flex w-full" v-if="form.destination == 'shopify' && form.type == 'import'">
            <text-input v-model="form.destination_json.shop_domain" :error="form.errors.destination_json"
              class="pb-8 pr-6 w-full lg:w-1/2" label="Shop Domain" />
            <text-input v-model="form.destination_json.api_access_token" :error="form.errors.destination_json"
              class="pb-8 pr-6 w-full lg:w-1/2" label="Api Access Token" />
          </div>
          <div class="flex w-full" v-if="form.destination == 'magento' && form.type == 'import'">
            <text-input v-model="form.destination_json.api_url" :error="form.errors.destination_json"
              class="pb-8 pr-6 w-full lg:w-1/2" label="API Url" />
            <text-input v-model="form.destination_json.api_access_token" :error="form.errors.destination_json"
              class="pb-8 pr-6 w-full lg:w-1/2" label="API Access Token" />
          </div>
          <text-input v-model="form.shop" class="pb-8 pr-6 opacity-80 w-full" v-if="form.type == 'import'" label="Shop"
            disabled />
          <text-input v-model="form.import_type" class="pb-8 pr-6 opacity-80 w-full" v-if="form.type == 'import'"
            label="Import Type" disabled />
          <div class="pb-8 flex pr-6 w-full" v-if="form.type == 'import' && form.destination == 'shopify'">
            <label class="form-label" for="accept">Enable FeatureLines Mapping</label>
            <input type="checkbox" v-model="form.is_filter" class="ml-5" disabled />
          </div>
          <div class="pb-8 pr-6 items-center w-full" v-if="message">
            <div class="flex items-center justify-between bg-red-500 rounded">
              <div class="flex items-center">
                <svg class="flex-shrink-0 ml-4 mr-2 w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20">
                  <path
                    d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.41-1.41A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.49L11.41 10l2.83 2.83-1.41 1.41L10 11.41l-2.83 2.83-1.41-1.41L8.59 10 5.76 7.17l1.41-1.41L10 8.59l2.83-2.83 1.41 1.41z" />
                </svg>
                <div class="py-4 text-white text-sm font-medium">{{ message }}</div>
              </div>
            </div>
          </div>
          <LoadingBar class="w-full flex pb-8 justify-center items-center" v-if="isLoading" />

          <div class="flex w-full flex-wrap" v-if="filterFields != null && typeof featurelineFields == 'object'">
            <div class="pb-4 pr-6 w-full">FeatureLine Fields Mapping :</div>
            <div class="pr-6 mb-6 mr-6 flex flex-wrap form-input w-full">
              <label class="pb-4 pl-2 mt-2 form-label"
                v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">Source:</label>
              <label class="pb-4 pl-2 mt-2 form-label"
                v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">Destination:</label>
              <label v-if="form.destination === 'magento'" class="pb-4 pl-2 mt-2 form-label"
                v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">Type:</label>
              <div v-for="(input, index) in filter_mapping_json" :key="`jsonInput-${index}`"
                class="input pb-5 wrapper w-full -center flex items-center mb-3">
                <div class="mr-2 h-10 rounded-lg outline-none"
                  v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">

                  <select v-if="level3Shops.includes(form.shop)" v-model="input.source" class="form-select">
                    <option></option>
                    <option v-for="(filterField, filterIndex) in filterFields" :key="filterIndex" :value="filterIndex">{{
                      filterField }}
                    </option>
                  </select>
                  <select v-else v-model="input.source" class="form-select">
                    <option></option>
                    <option v-for="filterField in filterFields" :key="filterField" :value="filterField">{{ filterField }}
                    </option>
                  </select>
                </div>
                <div class="mr-2 h-10 rounded-lg outline-none"
                  v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">
                  <text-input v-model="input.destination" />
                </div>
                <div class="mr-2 h-10 rounded-lg outline-none" v-if="form.destination === 'magento'"
                  v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">
                  <select v-model="input.type" class="form-select">
                    <option value="text" selected>Text</option>
                    <option value="select">Dropdown</option>
                    <option v-if="level3Shops.includes(form.shop)" value="number">number</option>
                  </select>
                </div>
                <icon name="plus" @click="addField(input, filter_mapping_json, 'filter_mapping_json')" />
                <icon name="remove" v-show="filter_mapping_json.length > 1"
                  @click="removeField(index, filter_mapping_json)" />
              </div>
              <div v-if="filterError" class="w-full mb-3 text-center form-error">{{ filterError }}</div>

              <div v-if="form.destination == 'shopify'" class="w-full mb-3 text-left text-black font-light">
                <span><span class="font-normal">*Note :</span> Before import we need to manually create product metafield
                  definitions for " </span>
                <span>{ destination }</span>
                <span>"</span>
                <div class="w-full pt-2">
                  <span class="w-full font-normal">How to create definition ? </span>
                  <div class="w-full pl-6">1. Create definition
                    "https://{shop-name}.myshopify.com/admin/metafields/product/create"</div>
                  <div class="w-full pl-6">2. Name : {destination}</div>
                  <div class="w-full pl-6">3. Namespace and key : FeatureLine.{destination} (Ex. FeatureLine.Brand)</div>
                  <div class="w-full pl-6">4. Give access to Storefront API requests</div>
                  <div class="w-full pl-6">5. Content Type : Text(Single-line-text)</div>
                </div>
                <div class="w-full pt-2">That's All, Add this definition to filter
                  "https://{shop-name}.myshopify.com/admin/menus"</div>
              </div>
            </div>
          </div>

          <div v-if="featurelineFields && typeof featurelineFields == 'object' && level3Shops.includes(form.shop)"
            class="pb-8 pr-6 w-full">
            <lable class="form-label">Select JSON Featureline Fields :</lable>
            <ul class="flex flex-wrap form-input w-full">
              <li class="mt-1 mb-1 lg:w-1/3 pl-8" v-for="(featurelineField, featurelineFieldIndex) in featurelineFields"
                :key="featurelineFieldIndex">
                <input type="checkbox" :value="featurelineFieldIndex" v-bind:id="featurelineFieldIndex"
                  v-model="form.store_featureline_fields" />
                {{ featurelineField }}
              </li>
            </ul>
          </div>

          <!-- Custom metafield Mapping -->
          <div v-if="form.type == 'import'" class="w-full">
            <div class="pb-4 pr-6 w-full">Custom Metafields Mapping :</div>
            <div class="form-input flex flex-wrap mb-6 mr-6 pr-6 w-full">
              <label class="form-label mt-2 pb-4 pl-2"
                v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">Source:</label>
              <label class="form-label mt-2 pb-4 pl-2"
                v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">Destination:</label>
              <label v-if="form.destination === 'magento'" class="form-label mt-2 pb-4 pl-2"
                v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">Type:</label>
              <div v-for="(input, index) in custom_metafield_json" :key="`jsonInput-${index}`"
                class="input wrapper -center flex items-center mb-3 pb-5 w-full">
                <div class="mr-2 h-10 rounded-lg outline-none"
                  v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">
                  <select v-model="input.source" class="form-select">
                    <option></option>
                    <option v-for="sourceItemField in sourceItemFields" :key="sourceItemField" :value="sourceItemField">{{
                      sourceItemField }}</option>
                  </select>
                </div>
                <div class="mr-2 h-10 rounded-lg outline-none"
                  v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">
                  <text-input v-model="input.destination" />
                </div>
                <div class="mr-2 h-10 rounded-lg outline-none" v-if="form.destination === 'magento'"
                  v-bind:class="form.destination === 'magento' ? 'w-1/3' : 'w-1/2'">
                  <select v-model="input.type" class="form-select">
                    <option value="text" selected>Text</option>
                    <option value="select">Dropdown</option>
                  </select>
                </div>
                <icon name="plus" @click="addField(input, custom_metafield_json, 'custom_metafield_json')" />
                <icon name="remove" v-show="custom_metafield_json.length > 1"
                  @click="removeField(index, custom_metafield_json)" />
              </div>
              <div v-if="form.destination == 'shopify'" class="w-full mb-3 text-left text-black font-light">
                <span><span class="font-normal">*Note :</span> Before import we need to manually create product metafield
                  definitions for " </span>
                <span>{ destination }</span>
                <span>"</span>
                <div class="w-full pt-2">
                  <span class="w-full font-normal">How to create definition ? </span>
                  <div class="w-full pl-6">1. Create definition
                    "https://{shop-name}.myshopify.com/admin/metafields/product/create"</div>
                  <div class="w-full pl-6">2. Name : {destination}</div>
                  <div class="w-full pl-6">3. Namespace and key : FeatureLine.{destination} (Ex. FeatureLine.Brand)</div>
                  <div class="w-full pl-6">4. Give access to Storefront API requests</div>
                  <div class="w-full pl-6">5. Content Type : Text(Single-line-text)</div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex w-full flex-wrap" v-if="sourceItemFields != null && form.type == 'import'">
            <div class="pb-4 pr-6 w-full">Image :</div>
            <div class="form-input pb-8 pr-6 w-full mb-6 mr-6">
              <div class="input pb-5 wrapper w-full -center flex items-center mb-3">
                <div class="h-10 w-1/2 rounded-lg outline-none mr-2">
                  <text-input v-model="form.image_url" :error="form.errors.image_url" label="Image URL" />
                </div>
                <div class="h-10 w-1/2 rounded-lg outline-none mr-2">
                  <select-input v-model="form.image_identifier" :error="form.errors.image_identifier"
                    label="Image Identifier">
                    <option :value="null" />
                    <option v-for="sourceItemField in sourceItemFields" :key="sourceItemField" :value="sourceItemField">{{
                      sourceItemField }}</option>
                  </select-input>
                </div>
              </div>
            </div>
          </div>

          <!-- Source Primary Key -->
          <div class="flex w-full flex-wrap" v-if="sourceItemFields != null && form.type == 'import'">
            <div class="pb-4 pr-6 w-full">Source Primary Key :</div>
            <div class="form-input pb-8 pr-6 w-full mb-6 mr-6">
              <div class="input pb-5 wrapper w-full -center flex items-center mb-3">
                <div class="h-10 w-full rounded-lg outline-none mr-2">
                  <select-input v-model="form.source_primary_key" :error="form.errors.source_primary_key" label="Source">
                    <option :value="null" />
                    <option v-for="sourceItemField in sourceItemFields" :key="sourceItemField" :value="sourceItemField">{{
                      sourceItemField }}</option>
                  </select-input>
                </div>
              </div>
            </div>
          </div>

          <div class="flex w-full flex-wrap" v-if="sourceItemFields != null && form.destination != 'webservice'">
            <div class="pb-4 pr-6 w-full" v-if="form.type == 'import'">Product Fields Mapping :</div>
            <div class="pb-4 pr-6 w-full" v-if="form.type == 'export'">Fields Mapping :</div>
            <div class="pr-6 mb-6 mr-6 flex flex-wrap form-input w-full">
              <label class="w-1/2 pb-4 pl-2 mt-2 form-label">Source:</label>
              <label class="w-1/2 pb-4 pl-2 mt-2 form-label">Destination:</label>
              <div v-for="(input, index) in mapping_json" :key="`jsonInput-${index}`"
                class="input pb-5 wrapper w-full -center flex items-center mb-3">
                <div class="h-10 w-1/2 rounded-lg outline-none mr-2">
                  <select v-model="input.source" class="form-select">
                    <option></option>
                    <option v-for="sourceItemField in sourceItemFields" :key="sourceItemField" :value="sourceItemField">{{
                      sourceItemField }}</option>
                  </select>
                </div>
                <div class="h-10 w-1/2 rounded-lg outline-none mr-2">
                  <select v-model="input.destination" class="form-select" v-if="form.type == 'import'">
                    <option></option>
                    <option v-for="destinationItemField in destinationItemFields" :key="destinationItemField"
                      :value="destinationItemField">{{ destinationItemField }}</option>
                  </select>
                  <text-input v-model="input.destination" v-if="form.type == 'export'" />
                </div>
                <icon name="plus" @click="addField(input, mapping_json, 'mapping_json')" />
                <icon name="remove" v-show="mapping_json.length > 1" @click="removeField(index, mapping_json)" />
              </div>
              <div v-if="itemError" class="w-full mb-3 text-center form-error">{{ itemError }}</div>
            </div>
          </div>

          <div class="w-full" v-if="form.type == 'import' && sourceCategoryFields != null">
            <div class="w-full flex flex-wrape">
              <div class="w-1/2 pb-4 flex flex-wrape">
                <input type="radio" name="category-mapping" id="category-automatic" value="1"
                  v-model="form.category_automatic_mapping" />
                <div class="w-full pl-2">Category Automatic Mapping</div>
              </div>
              <div class="w-1/2 pb-4 flex flex-wrape">
                <input type="radio" name="category-mapping" id="category-manually" value="0"
                  v-model="form.category_automatic_mapping" />
                <div class="w-full pl-2">Category Manually Mapping</div>
              </div>
            </div>
            <div class="flex w-full flex-wrap" v-if="form.category_automatic_mapping == 1">
              <div class="pr-6 mb-6 mr-6 flex flex-wrap form-input w-full">
                <label class="w-1/2 pb-4 pl-2 mt-2 form-label">Source:</label>
                <label class="w-1/2 pb-4 pl-2 mt-2 form-label">Destination:</label>
                <div v-for="(input, index) in category_mapping_json" :key="`jsonInput-${index}`"
                  class="input pb-5 wrapper w-full -center flex items-center mb-3">
                  <div class="h-10 w-1/2 rounded-lg outline-none mr-2">
                    <select v-model="input.source" class="form-select">
                      <option></option>
                      <option v-for="sourceCategoryField in sourceCategoryFields" :key="sourceCategoryField"
                        :value="sourceCategoryField">{{ sourceCategoryField }}</option>
                    </select>
                  </div>
                  <div class="h-10 w-1/2 rounded-lg outline-none mr-2">
                    <select v-model="input.destination" class="form-select" v-if="form.type == 'import'">
                      <option></option>
                      <option v-for="destinationCategoryField in destinationCategoryFields"
                        :key="destinationCategoryField" :value="destinationCategoryField">{{ destinationCategoryField }}
                      </option>
                    </select>
                    <text-input v-model="input.destination" v-if="form.type == 'export'" />
                  </div>
                  <icon name="plus" @click="addField(input, category_mapping_json, 'category_mapping_json')" />
                  <icon name="remove" v-show="category_mapping_json.length > 1"
                    @click="removeField(index, category_mapping_json)" />
                </div>
                <div v-if="categoryError" class="w-full mb-3 text-center form-error">{{ categoryError }}</div>
              </div>
            </div>
            <div class="flex w-full flex-wrap" v-if="form.category_automatic_mapping == 0">
              <div class="pr-6 mb-6 mr-6 flex flex-wrap form-input w-full">
                <label class="w-1/2 pb-4 pl-2 mt-2 form-label">Source:</label>
                <label class="w-1/2 pb-4 pl-2 mt-2 form-label">Destination:</label>
                <div v-for="(input, index) in category_manually_mapping_json" :key="`jsonInput-${index}`"
                  class="input pb-5 wrapper w-full -center flex items-center mb-3">
                  <div class="h-10 w-1/2 rounded-lg outline-none mr-2">
                    <text-input v-model="input.source" />
                  </div>
                  <div class="h-10 w-1/2 rounded-lg outline-none mr-2">
                    <text-input v-model="input.destination" />
                  </div>
                  <icon name="plus"
                    @click="addField(input, category_manually_mapping_json, 'category_manually_mapping_json')" />
                  <icon name="remove" v-show="category_manually_mapping_json.length > 1"
                    @click="removeField(index, category_manually_mapping_json)" />
                </div>
                <div v-if="categoryError" class="w-full mb-3 text-center form-error">{{ categoryError }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" :disabled="isLoading == true ? true : false"
            class="btn-indigo ml-auto" type="submit">Update Connector</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import axios from 'axios'
import LoadingBar from '@/Shared/LoadingBar'

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TrashedMessage,
    TextInput,
    LoadingBar,
  },
  layout: Layout,
  props: {
    connector: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        title: this.connector.title,
        type: this.connector.type,
        image_url: this.connector.image_url,
        image_identifier: this.connector.image_identifier,
        import_type: this.connector.import_type,
        source: this.connector.source,
        destination: this.connector.destination,
        shop: this.connector.shop,
        source_json: JSON.parse(this.connector.source_json),
        destination_json: JSON.parse(this.connector.destination_json),
        mapping_json: JSON.stringify(JSON.parse(this.connector.mapping_json), null, 2),
        category_automatic_mapping: this.connector.category_automatic_mapping,
        category_mapping_json: JSON.stringify(JSON.parse(this.connector.category_mapping_json), null, 2),
        category_manually_mapping_json: JSON.stringify(JSON.parse(this.connector.category_manually_mapping_json), null, 2),
        filter_mapping_json: JSON.stringify(JSON.parse(this.connector.filter_mapping_json), null, 2),
        custom_metafield_json: JSON.stringify(JSON.parse(this.connector.custom_metafield_json), null, 2),
        source_primary_key: this.connector.source_primary_key,
        is_filter: this.connector.is_filter == 1 ? true : false,
        store_featureline_fields: this.connector.store_featureline_fields ? this.connector.store_featureline_fields.split(',') : []
      }),

      allShops: ['euronics', 'elsalg', 'vores', 'lyspunkt', 'photocare', 'lysmesteren'],
      level1Shops: ['euronics', 'vores', 'lyspunkt', 'photocare', 'lysmesteren'],
      level3Shops: ['elsalg'],

      sourceItemFields: null,
      sourceCategoryFields: null,
      destinationItemFields: null,
      destinationCategoryFields: null,
      filterFields: null,
      featurelineFields: null,

      message: null,

      mapping_json: [],
      category_mapping_json: [],
      category_manually_mapping_json: [],
      filter_mapping_json: [],
      custom_metafield_json: [],
      itemError: null,
      categoryError: null,
      filterError: null,

      isLoading: true,
    }
  },
  async mounted() {
    await axios
      .post('/connectors/items', { type: this.form.type, import_type: this.form.import_type, source: this.form.source, destination: this.form.destination, shop: this.form.shop, export: this.form.source_json.export, is_filter: this.form.is_filter })
      .then((response) => {
        if (!response.data.message) {
          this.sourceItemFields = response.data.source_item_fields
          this.sourceCategoryFields = response.data.source_category_fields
          this.destinationItemFields = response.data.destination_item_fields
          this.destinationCategoryFields = response.data.destination_category_fields
          if (this.level1Shops.includes(this.form.shop)) {
            this.filterFields = response.data.filter_fields
          } else {
            this.filterFields = response.data.featureline_fields
          }
          this.featurelineFields = response.data.featureline_fields
          this.isLoading = false
        } else {
          this.message = response.data.message
          this.isLoading = false
        }
      })
      .catch((error) => {
        console.error(error)
      })

    let itemObj = JSON.parse(this.connector.mapping_json)
    for (let i = 0; i < Object.keys(itemObj).length; i++) {
      let source = Object.keys(itemObj)[i]
      let destination = itemObj[source]
      let newItemObj = {
        source: source,
        destination: destination,
      }
      this.mapping_json.push(newItemObj)
    }
    if (this.mapping_json.length == 0) {
      this.mapping_json = [{ source: '', destination: '' }]
    }

    let categoryObj = JSON.parse(this.connector.category_mapping_json)
    for (let i = 0; i < Object.keys(categoryObj).length; i++) {
      let source = Object.keys(categoryObj)[i]
      let destination = categoryObj[source]
      let newCategoryObj = {
        source: source,
        destination: destination,
      }
      this.category_mapping_json.push(newCategoryObj)
    }
    if (this.category_mapping_json.length == 0) {
      this.category_mapping_json = [{ source: '', destination: '' }]
    }

    let categoryManuallyObj = JSON.parse(this.connector.category_manually_mapping_json)
    for (let i = 0; i < Object.keys(categoryManuallyObj).length; i++) {
      let source = Object.keys(categoryManuallyObj)[i]
      let destination = categoryManuallyObj[source]
      let newCategoryManuallyObj = {
        source: source,
        destination: destination,
      }
      this.category_manually_mapping_json.push(newCategoryManuallyObj)
    }
    if (this.category_manually_mapping_json.length == 0) {
      this.category_manually_mapping_json = [{ source: '', destination: '' }]
    }

    let filterObj = JSON.parse(this.connector.filter_mapping_json)

    if (this.connector.destination === 'magento') {
      for (let i = 0; i < Object.keys(filterObj).length; i++) {
        let source = Object.keys(filterObj)[i]
        let destination = filterObj[source].key
        let type = filterObj[source].type
        let newFilterObj = {
          source: source,
          destination: destination,
          type: type,
        }
        this.filter_mapping_json.push(newFilterObj)
      }
    } else {
      for (let i = 0; i < Object.keys(filterObj).length; i++) {
        let source = Object.keys(filterObj)[i]
        let destination = filterObj[source]
        let newFilterObj = {
          source: source,
          destination: destination,
        }
        this.filter_mapping_json.push(newFilterObj)
      }
    }
    if (this.filter_mapping_json.length == 0) {
      this.filter_mapping_json = [{ source: '', destination: '', type: 'text' }]
    }

    let metafieldObj = JSON.parse(this.connector.custom_metafield_json)
    if (this.connector.destination === 'magento') {
      for (let i = 0; i < Object.keys(metafieldObj).length; i++) {
        let source = Object.keys(metafieldObj)[i]
        let destination = metafieldObj[source].key
        let type = metafieldObj[source].type
        let newFilterObj = {
          source: source,
          destination: destination,
          type: type,
        }
        this.custom_metafield_json.push(newFilterObj)
      }
    } else {
      for (let i = 0; i < Object.keys(metafieldObj).length; i++) {
        let source = Object.keys(metafieldObj)[i]
        let destination = metafieldObj[source]
        let newFilterObj = {
          source: source,
          destination: destination,
        }
        this.custom_metafield_json.push(newFilterObj)
      }
    }
    if (this.custom_metafield_json.length == 0) {
      this.custom_metafield_json = [{ source: '', destination: '', type: 'text' }]
    }
  },
  methods: {
    update() {
      let itemJson = {}
      let categoryJson = {}
      let categoryManuallyJson = {}
      let filterJson = {}
      let metafieldJson = {}

      this.mapping_json.forEach((element) => {
        if (element.source && element.destination) {
          let data = {
            [element.source]: element.destination,
          }
          Object.assign(itemJson, data)
        }
      })
      this.category_mapping_json.forEach((element) => {
        if (element.source && element.destination) {
          let data = {
            [element.source]: element.destination,
          }
          Object.assign(categoryJson, data)
        }
      })
      this.category_manually_mapping_json.forEach((element) => {
        if (element.source && element.destination) {
          let data = {
            [element.source]: element.destination,
          }
          Object.assign(categoryManuallyJson, data)
        }
      })

      if (this.form.destination === 'magento') {
        this.filter_mapping_json.forEach((element) => {
          if (element.source && element.destination) {
            let data = {
              [element.source]: {
                key: element.destination,
                type: element.type,
              },
            }
            Object.assign(filterJson, data)
          }
        })
      } else {
        this.filter_mapping_json.forEach((element) => {
          if (element.source && element.destination) {
            let data = {
              [element.source]: element.destination,
            }
            Object.assign(filterJson, data)
          }
        })
      }

      if (this.form.destination === 'magento') {
        this.custom_metafield_json.forEach((element) => {
          if (element.source && element.destination) {
            let data = {
              [element.source]: {
                key: element.destination,
                type: element.type,
              },
            }
            Object.assign(metafieldJson, data)
          }
        })
      } else {
        this.custom_metafield_json.forEach((element) => {
          if (element.source && element.destination) {
            let data = {
              [element.source]: element.destination,
            }
            Object.assign(metafieldJson, data)
          }
        })
      }

      this.form.mapping_json = JSON.stringify(itemJson, null, 2)
      this.form.category_mapping_json = JSON.stringify(categoryJson, null, 2)
      this.form.category_manually_mapping_json = JSON.stringify(categoryManuallyJson, null, 2)
      this.form.filter_mapping_json = JSON.stringify(filterJson, null, 2)
      this.form.custom_metafield_json = JSON.stringify(metafieldJson, null, 2)
      this.form.source_json = JSON.stringify(this.form.source_json, null, 2)
      this.form.destination_json = JSON.stringify(this.form.destination_json, null, 2)

      this.form.put(`/connectors/${this.connector.id}`)

      this.form.source_json = JSON.parse(this.form.source_json)
      this.form.destination_json = JSON.parse(this.form.destination_json)
    },
    addField(value, fieldType, type) {
      this.itemError = null
      this.categoryError = null
      this.filterError = null
      if (value.source == '' || value.destination == '') {
        if (type == 'category_mapping_json') {
          this.categoryError = 'please select source and destination.'
        } else if (type == 'mapping_json') {
          this.itemError = 'please select source and destination.'
        } else if (type == 'filter_mapping_json') {
          this.filterError = 'please select source and destination.'
        }
      } else {
        if (this.form.destination === 'shopify' && type == 'filter_mapping_json' && fieldType.length >= 20) {
          this.filterError = 'You reached at maximum field to add.'
          return
        }
        fieldType.push({ source: '', destination: '', type: 'text' })
      }
    },
    removeField(index, fieldType) {
      fieldType.splice(index, 1)
    },
  },
}
</script>
